import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, filter, take } from 'rxjs';
import { MyUserService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private myUserService: MyUserService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.myUserService.user$.pipe(
      // Wait until user is loaded (userID exists) or explicitly null/empty
      filter((user) => !!user && (!!user.userID || user.userID === null)),
      take(1),
      map((user) => {
        // Check if user is logged in and is an administrator
        if (user && user.userID && user.isAdmin) {
          return true;
        }
        
        // Redirect to home if not admin
        this.router.navigate(['/']);
        return false;
      })
    );
  }
}